export const userAssignmentPermissionOptions = [
  {value: 'ProjectEditor', displayName: 'Project Editor', description: 'Project Editor - View all, Edit all'},
  {value: 'ReadWriteAll', displayName: 'View all, Edit all', description: 'View all, Edit all'},
  {value: 'ReadAllWriteOwn', displayName: 'View all, Edit own', description: 'View all, Edit own'},
  {value: 'ReadAllWriteNone', displayName: 'View all, Edit none', description: 'View all, Edit none'},
  {value: 'ReadWriteOwn', displayName: 'View own, Edit own', description: 'View own, Edit own'},
];